import { render } from "./PlanilhasSolucoes.vue?vue&type=template&id=0cd1e58f"
import script from "./PlanilhasSolucoes.vue?vue&type=script&lang=js"
export * from "./PlanilhasSolucoes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__